import { Range, Transforms } from 'slate'
import isUrl from 'is-url'
import axios from 'axios'

import imageExtensions from './imageExtensions'
import { getAssetType } from '../contentstack/image/Modal/util'
import { handleUpload } from '../../../../lib/requestModule'

export const isSelectionCollapsed = (selection) => {
  return Range.isCollapsed(selection)
}
export const insertImage = async (editor, url, extraAttrs = {}) => {
  const selection = editor.selection || editor.savedSelection;

  let image;
  if (url.startsWith('data')) { // upload to assets

    let fileArray = url.split(','),
      mime = fileArray[0].match(/:(.*?);/)[1],
      bstr = atob(fileArray[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    const fileToUpload = new File([u8arr], 'image.png', { type: mime });
    const requestProps: Object = editor?.requestProps || {};
    const folderUid = ''
    const imgUploadRes: any = await uploadImage({ ...requestProps, files: [fileToUpload], folderUid })
    if (imgUploadRes) {
      const isImage = Array.from(imgUploadRes).some(instance => getAssetType(instance?.['asset']?.['content_type']) === null);

      if (isImage) {
        image = {
          type: 'img',
          attrs: {
            url: imgUploadRes[0].asset.url,
            width: null,
            height: 'auto',
            "redactor-attributes": { ...extraAttrs }
          },
          children: [{ text: '' }]
        }
      }
    }
  } else {
    const alt = extraAttrs["alt"] ?? ''
    delete extraAttrs["alt"]
    image = {
      type: 'img',
      attrs: {
        url,
        width: null,
        alt,
        height: 'auto',
        "redactor-attributes": { ...extraAttrs }
      },
      children: [{ text: '' }]
    }
  }
  if (selection)
    Transforms.insertNodes(editor, image, { at: selection });
  else Transforms.insertNodes(editor, image)
}

export const isImageUrl = (url) => {
  if (!url) return false
  if (!isUrl(url)) return false
  const ext = new URL(url).pathname.split('.').pop()
  return imageExtensions.includes(ext)
}

export const uploadImage = async (props) => {
  const { apiKey, assetUrl, authToken, files, folderUid, branch, isPlugin } = props
  let url = `${assetUrl}/assets`;

  if (isPlugin) {
    const res = await handleUpload(files, folderUid);
    return res.data;
  }
  return Promise.all(files.map(async file => {
    let formData = new FormData()
    formData.append('asset[upload]', file, file.name);
    formData.append('asset[parent_uid]', folderUid);
    const headers = {
      api_key: apiKey,
      'Content-Type': 'application/json'
    }
    authToken && (headers['authToken'] = authToken);
    branch && (headers['branch'] = branch);
    const res = await axios({
      method: 'POST',
      url,
      headers,
      data: formData
    });
    return res.data;
  }))
}